import axios from 'axios';

export async function checkRepAccess(rep_id) {
  try {
    const { data } = await axios.post('v2/check-rep-access', { rep_id });
    console.log(`Rep access for ${rep_id}:`, data);
    return data.access_allowed;
  } catch (err) {
    console.error('Error checking rep access:', err);
    return false;
  }
}
